export default () => {
    return $(function(){
        $('#search-glossary-form').on('submit', function(e){
            e.preventDefault();
            var category = $('#search-glossary-category').val();
            var q = $('#search-glossary-termq').val();
            var url = '/herramientas/diccionario';

            if(category !== '-1') url += '/' + category;
            //Añadir término de búsqueda solo si es la misma categoría
            if(q !== '') url += '?q=' + q;
            window.location = url;
        });
    });
}
